import cn from "classnames";
import { Nullable } from "shared/lib/typeCheck.lib";
import { CardRow } from "./CardRow";
import styles from "../Card.module.scss";

export interface CardDirectionProps {
  from?: string | null;
  to?: string | null;
  reference?: Nullable<string>;
  className?: string;
}

export const CardDirection: RFC<CardDirectionProps> = ({ from, to, className, reference }) => {
  return (
    <CardRow className={cn(styles.directions, className)}>
      {from && (
        <span className={styles.direction} data-test-id={`card-direction-from-${reference}`}>
          {from}
        </span>
      )}
      {to && (
        <span className={styles.direction} data-test-id={`card-direction-to-${reference}`}>
          {to}
        </span>
      )}
    </CardRow>
  );
};

CardDirection.displayName = CardDirection.name;
